module.exports = __webpack_public_path__ + "static/media/icon-line-technology.16ca5fdc.svg";